var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PSelectKeyValue',{attrs:{"options":_vm.currencies,"value":_vm.value,"label":"label","track-by":"value","placeholder":_vm.$pgettext('core.label','Select Currency')},on:{"input":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }